<div class="px-2 lg:px-8 m-auto max-w-[1600px] pb-6 py-6 mt-12 mb-12">
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-8">
    <div class="flex flex-col justify-start">
      <!-- <h1 class="text-4xl mb-8 font-bold">{{ { key: 'bookHall' } | i18n }}</h1> -->
      <h1 class="text-4xl mb-8 font-bold">Campingplätze</h1>
      <p>
        Du hast einen Wettkampf, einen Kurs oder ein Seminar in unserer
        <a class="text-primary-600" href="https://hundesport-sg.ch/infrastruktur/" target="_blank">Halle</a> gebucht. Du reist mit dem
        Wohnmobil oder dem Wohnwagen an. Wähle den Anlass aus und buche deinen Campingplatz. Die
        <a class="text-primary-600" href="https://hundesport-sg.ch/infrastruktur/" target="_blank">Duschen und die WC-Anlagen</a> sind
        nachts durchgehend zugänglich. Der Mehrzweck-/Gastroraum gemäss Informationen der Organisator*innen. Spezialwünsche auf
        <a class="text-primary-600" href="mailto:daniela.weber@hundesport-sg.ch" target="_blank">Anfrage</a>.
      </p>
    </div>

    <img class="h-96 w-full object-cover object-top" src="/assets/images/flugaufnahme.jpeg" alt="Halle" />
  </div>
</div>

<div class="w-full py-12 bg-primary-600 flex flex-row items-center justify-center">
  <!-- <h2 class="text-3xl font-bold text-white text-center m-0">{{ { key: 'offers' } | i18n }}</h2> -->
  <h2 class="text-3xl font-bold text-white text-center m-0">Anlässe</h2>
</div>

@if (periods.isLoading()) {
  <div class="flex justify-center items-center h-64">
    <app-loading [noWhitespace]="true"></app-loading>
  </div>
} @else if (periods.error()) {
  <div class="flex justify-center items-center h-64">
    <div class="text-red-500">{{ { key: 'errorLoading' } | i18n }}</div>
  </div>
} @else {
  @if (periods.value(); as ps) {
    <div class="grid grid-cols-1 gap-6 px-2 lg:px-8 m-auto max-w-[1600px] pb-6 py-6 mt-12 mb-12">
      @for (p of ps; track p._id) {
        <a
          [routerLink]="['/camping', p._id]"
          class="p-4 flex flex-col gap-4 text-center rounded-md border border-primary-500 hover:bg-opacity-50 hover:bg-primary-600"
        >
          <div class="font-bold">
            {{ p.designation | i18n }}
          </div>
          <div class="text-sm">
            {{ formatDate(p.from) }} -
            {{ formatDate(p.until) }}
          </div>
        </a>
      } @empty {
        <div class="text-center text-gray-500">Aktuell sind keine Anlässe geplant...</div>
      }
    </div>
  }
}
